import { render, staticRenderFns } from "./CouponHistoryModal.vue?vue&type=template&id=c429878c"
import script from "./CouponHistoryModal.vue?vue&type=script&lang=js"
export * from "./CouponHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports